import React from 'react';

// Question types
import DualIntegersDualAnswers from '../questions/dual_integers_dual_answers';
import DualOptionSetsSingleAnswer from '../questions/dual_option_sets_single_answer';
import SingleOptionSetSingleAnswer from '../questions/single_option_set_single_answer';

const Answer = ({ question }) => {
  if (question.calculation_data) {
    switch (question.question_data.type) {
      case 'dual-integers-dual-answer':
        return (
          <DualIntegersDualAnswers data={question.calculation_data.answers} />
        );
      case 'dual-option-sets-single-answer':
        return (
          <DualOptionSetsSingleAnswer
            data={question.calculation_data.answers}
            question={question}
          />
        );
      case 'single-option-set-single-answer':
        return (
          <SingleOptionSetSingleAnswer
            data={question.calculation_data.answers}
            question={question}
          />
        );
      default:
        return null;
    }
  } else {
    return null;
  }
};

export default Answer;
